import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { comingFeatures2026 } from '../../data/features';
import styles from './ComingSoonSection.module.css';

const ComingSoonSection = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  return (
    <section className={styles.comingSoon} aria-labelledby="coming-soon-title">
      <div className={styles.container}>
        <div className={styles.header}>
          <motion.div
            className={styles.badge}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={inView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.5 }}
          >
            Coming in 2026
          </motion.div>
          <h2 id="coming-soon-title" className={styles.title}>
            What's Next
          </h2>
          <p className={styles.description}>
            Exciting new features on the horizon
          </p>
        </div>

        <motion.div
          ref={ref}
          className={styles.features}
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : { opacity: 0 }}
        >
          {comingFeatures2026.map((feature, index) => (
            <motion.div
              key={feature.id}
              className={styles.featureCard}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
            >
              <div className={styles.featureIcon}>{feature.icon}</div>
              <h3 className={styles.featureTitle}>{feature.title}</h3>
              <p className={styles.featureDescription}>{feature.description}</p>
              {feature.highlight && (
                <div className={styles.featureHighlight}>
                  <span className={styles.highlightIcon}>✨</span>
                  {feature.highlight}
                </div>
              )}
              <span className={styles.featureCategory}>{feature.category}</span>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ComingSoonSection;
